import { Paper } from '@mantine/core';

type LogoPaperProps = {
  children: React.ReactNode;
  p?: number;
};

export function LogoPaper({ children, p = 30 }: Readonly<LogoPaperProps>) {
  return (
    <Paper withBorder shadow="md" p={p} radius="md">
      {children}
    </Paper>
  );
}
